import script from "./WysiwygVisualizer.vue?vue&type=script&setup=true&lang=js"
export * from "./WysiwygVisualizer.vue?vue&type=script&setup=true&lang=js"

import "./WysiwygVisualizer.vue?vue&type=style&index=0&id=26a5cd90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a5cd90"]])

export default __exports__